import Review from '@/modules/api/review'
import Product from '@/modules/api/product'
import kameleoon from '@/modules/services/kameleoon'
import * as filterMutations from './reviews-filter-mutations'

const recentSort = 'recent'

const state = {
  reviews: [],
  errors: [],
  sortBy: setSortDefaultValueBasedOnFlag(),
  filterByCountry: null,
  filterByVariantIds: [],
  filterByRating: null,
  showMobileFilter: false,
  meta: {},
  page: 1,
  count: 0,
  reviewsLoading: true,
  excludeUSReviewsFilterLabel: null,
  excludeUSReviewsFilter: false,
  showCountryDropdown: false,
  showSortDropdown: false,
  showFilterDropdown: false,
  selectedVariantIds: [],
  selectedCountryCodes: [],
  selectedRatings: []
}

const mutations = {
  ...filterMutations,

  setReviews (state, reviews) {
    state.reviews = reviews
  },

  setErrors (state, errors) {
    state.errors = errors
  },

  setReviewsCount (state, count) {
    state.count = count
  },

  setReviewsMeta (state, meta) {
    state.meta = meta
  },

  setShowCountryDropdown (state, boolean) {
    state.showCountryDropdown = boolean
  },

  setShowSortDropdown (state, boolean) {
    state.showSortDropdown = boolean
  },

  setShowFilterDropdown (state, boolean) {
    state.showFilterDropdown = boolean
  },

  setReviewsPage (state, page) {
    state.page = page
  },

  setReviewsLoading (state, boolean) {
    state.reviewsLoading = boolean
  },

  setExcludeUSReviewsFilterLabel (state, object) {
    state.excludeUSReviewsFilterLabel = object
  },

  resetReviewsFilters (state) {
    state.selectedVariantIds = []
    state.selectedCountryCodes = []
    state.selectedRatings = []
    state.filterByVariantIds = []
    state.filterByCountry = null
    state.filterByRating = null
    state.excludeUSReviewsFilter = false
    state.sortBy = setSortDefaultValueBasedOnFlag()
    state.page = 1
  },

  removeReviewError (state, attribute) {
    state.errors = state.errors.filter(error => error.attribute !== attribute)
  }
}

const actions = {
  async fetchReviews ({ commit, state }, args) {
    commit('setReviewsLoading', true)

    try {
      const { data, meta, links } = await new Product().fetchProductReviews(args.id, {
        page: state.page,
        sort: state.sortBy,
        country: state.filterByCountry,
        variantIds: state.filterByVariantIds,
        excludeUSReviews: state.excludeUSReviewsFilter,
        rating: state.filterByRating
      })

      commit('setReviews', data)
      commit('setReviewsCount', meta.total)
      commit('setReviewsMeta', meta)
      commit('setExcludeUSReviewsFilterLabel', links['native-only'])
    } catch {}

    commit('setReviewsLoading', false)
  },

  async createReview ({ commit, dispatch }, args) {
    try {
      await new Review().create(args)
    } catch (error) {
      setReviewErrors(commit, error)
    }
  },

  async updateReview ({ commit, dispatch }, args) {
    try {
      await new Review().put(args)
    } catch (error) {
      setReviewErrors(commit, error)
    }
  }
}

const setReviewErrors = function (commit, error) {
  commit('setErrors', error.response.data['errors'].filter((error) => error?.attribute))
}

function setSortDefaultValueBasedOnFlag () {
  return kameleoon.isFeatureFlagActive('enable_enhanced_mweb_review_page') ? null : recentSort
}

export default {
  state,
  mutations,
  actions
}
